/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { Dialog } from "../../../dialogs/Dialog";
import { IEditor } from "../../../IEditor";
import { ResourceService } from "../../../resources/ResourceService";
import { ResourceListDialogComponent } from "./ResourceListDialogComponent";
import { IResourceListProps } from "../../../ui/components/ResourceList";

export interface ResourceListDialog_Params {
	/** List of allowed resource type to select */
	allowedResourceTypes?: RESOURCE_TYPES[];
	selectedResourceId?: string;
	title?: string;
	icon?: string;
	description?: string;
	isSelectable?: IResourceListProps["isSelectable"];
	isDisabled?: IResourceListProps["isDisabled"];
}

export interface ResourceListDialog_Result {
	resourceId: string;
}

export class ResourceListDialog extends Dialog<ResourceListDialog_Params, ResourceListDialog_Result> {
	private resourceService: ResourceService;

	/**
	 * Dialog constructor
	 *
	 * @param dc Dependency container
	 * @param id Dialog ID
	 * @param params Open params
	 */
	public constructor(dc: IEditor, id: string, params: ResourceListDialog_Params) {
		super(dc, id, params);

		this.resourceService = this.dc.get("resourceService");
	}

	public getResourceService(): ResourceService {
		return this.resourceService;
	}

	public getComponent(): typeof ResourceListDialogComponent {
		return ResourceListDialogComponent;
	}
}
